module.exports = __webpack_public_path__ + "media/images/avatar/06-b494dac1d22b516ad966d74db2014b1b.jpg";